import { makeStyles } from '@mui/styles'

const styles = makeStyles(() => ({
  root: {
    width: '100%',
    minWidth: 500,
    minHeight: 'calc(300px - 2rem)',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '1rem',
    padding: '1rem',
    '@media (max-width: 500px)':{
      minWidth: 'calc(100vw - 1rem)',
    },
  },
  
  formContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '1rem',
    width: '100%',
  },

  form: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%',
  },

  formFields: {
    display: 'flex',
    alignItems: 'left',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '100%',
    gap: '1.25rem',
    marginTop: '1.25rem',
    borderRadius: 4,
  },

  dates: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '1.5rem',
    width: '100%',
  },

  times: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '1.5rem',
    width: '100%',

    '& > div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: '1.5rem',
      width: '50%',
    },
  },

  radioQuestion: {
    paddingTop: '1.25rem',
  },

  answersContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '1.5rem',
    width: '100%',
  },
  
  optionsList: {
    fontSize: '1.3rem',
  },

  fabContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '1rem',
    padding: '1rem',
    width: '100%',
  },
  
  buttonsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '1rem',
    padding: '1rem',
    width: '100%',
  },
  
  justified: {
    textAlign: 'justify',
  },
  
}))

export default styles
